import React, { createContext, useContext, useState, useCallback } from 'react';

const SponsorCodeContext = createContext();

export const SponsorCodeProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [isValidated, setIsValidated] = useState(sessionStorage.getItem("sponserCode") ? true : false);

    const openSponsorModal = useCallback(() => {
        if (sessionStorage.getItem("sponserCode")) {
            setIsValidated(true)
            return
        }
        setOpen(true)
    }, []);
    const closeSponsorModal = useCallback(() => setOpen(false), []);

    return (
        <SponsorCodeContext.Provider value={{ open, openSponsorModal, closeSponsorModal, isValidated, setIsValidated }}>
            {children}
        </SponsorCodeContext.Provider>
    );
};

export const useSponsorCode = () => {
    const context = useContext(SponsorCodeContext);
    if (!context) {
        throw new Error('useSponsorCode must be used within a SponsorCodeProvider');
    }
    return context;
};
